(function() {
		if (window.DLColorCardsInitialized) {
			return;
		}

		window.DLColorCardsInitialized = true;

		const previewSwatchImage = function(swatch) {
			const card = swatch && swatch.closest('[data-dl-color-card]');

			if (!card) {
				return;
			}

			const image = card.querySelector('.dl-color-card-image');
			const imageSrc = swatch.dataset.imageSrc || '';
			const imageSrcset = swatch.dataset.imageSrcset || '';

			if (!image || !imageSrc) {
				return;
			}

			if (imageSrcset) {
				image.srcset = imageSrcset;
			} else {
				image.removeAttribute('srcset');
			}

			image.src = imageSrc;
		};

		document.addEventListener('mouseover', function(event) {
			const swatch = event.target.closest('[data-dl-color-swatch]');

			if (!swatch || (event.relatedTarget && swatch.contains(event.relatedTarget))) {
				return;
			}

			previewSwatchImage(swatch);
		});

		document.addEventListener('focusin', function(event) {
			const swatch = event.target.closest('[data-dl-color-swatch]');

			if (swatch) {
				previewSwatchImage(swatch);
			}
		});

		document.addEventListener('click', function(event) {
			const swatch = event.target.closest('[data-dl-color-swatch]');

			if (!swatch) {
				return;
			}

			const card = swatch.closest('[data-dl-color-card]');

			if (!card) {
				return;
			}

			event.preventDefault();

			const colorName = swatch.dataset.colorName || '';
			const variantUrl = swatch.dataset.variantUrl || swatch.href;
			const imageSrc = swatch.dataset.imageSrc || '';
			const imageSrcset = swatch.dataset.imageSrcset || '';
			const price = swatch.dataset.price || '';
			const priceVaries = swatch.dataset.priceVaries === 'true';

			card.classList.add('is-changing-color');

			card.querySelectorAll('[data-dl-color-swatch]').forEach(function(item) {
				const active = item === swatch;

				item.classList.toggle('is-active', active);

				if (active) {
					item.setAttribute('aria-current', 'true');
				} else {
					item.removeAttribute('aria-current');
				}
			});

			const colorNameElement = card.querySelector('[data-dl-color-name]');

			if (colorNameElement) {
				colorNameElement.textContent = colorName;
			}

			const priceElement = card.querySelector('[data-dl-color-price]');

			if (priceElement && price) {
				priceElement.innerHTML =
					(priceVaries
						? '<span class="product-card-color-price__from">' + (card.dataset.labelFrom || '') + '</span>'
						: '') +
					'<span>' + price + '</span>';
			}

			if (variantUrl) {
				card.querySelectorAll('[data-dl-card-link]').forEach(function(link) {
					link.href = variantUrl;
				});
			}

			const image = card.querySelector('.dl-color-card-image');

			if (!image || !imageSrc) {
				card.classList.remove('is-changing-color');
				return;
			}

			const finish = function() {
				card.classList.remove('is-changing-color');
				image.removeEventListener('load', finish);
				image.removeEventListener('error', finish);
			};

			image.addEventListener('load', finish);
			image.addEventListener('error', finish);

			if (imageSrcset) {
				image.srcset = imageSrcset;
			} else {
				image.removeAttribute('srcset');
			}

			image.src = imageSrc;

			window.setTimeout(function() {
				card.classList.remove('is-changing-color');
			}, 800);
		});
	})();
